import React, { useEffect, useState } from 'react';
import { auth } from '../lib/firebase';
import NavBar from '../components/NavBar';
import { useNavigate } from 'react-router-dom';

const ProfilePage: React.FC = () => {
  const [user, setUser] = useState<any>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((u) => {
      setUser(u);
    });
    return () => unsubscribe();
  }, []);

  if (!user) {
    return <div className="flex justify-center items-center h-screen">Loading...</div>;
  }

  // Back button for NavBar leftSlot
  const backButton = (
    <button
      className="flex items-center gap-2 px-4 py-2 bg-[#daed6e] hover:bg-[#c5d85c] rounded-[12px] shadow transition-colors font-semibold text-black"
      onClick={() => navigate('/dashboard')}
      style={{ marginRight: 12 }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
      </svg>
      Back
    </button>
  );

  return (
    <div className="min-h-screen w-full bg-[#e1dcdc75] relative">
      {/* NavBar with back button, no profile/invite buttons */}
      <NavBar
        userName={user.displayName || user.email?.split('@')[0] || 'User'}
        onSignOut={async () => { await auth.signOut(); window.location.href = '/signin'; }}
        hideProfileButton
        hideInviteButton
        leftSlot={backButton}
      />
      <div className="flex justify-center items-center min-h-screen pt-32 pb-12 bg-[#e1dcdc75]">
        <div className="bg-white rounded-[20px] shadow-lg p-8 w-full max-w-md flex flex-col items-center relative border border-[#e7e7e7] mt-12">
          <div className="w-28 h-28 rounded-full bg-[#daed6e] flex items-center justify-center mb-4 shadow-lg border-4 border-white">
            {user.photoURL ? (
              <img src={user.photoURL} alt="Avatar" className="w-full h-full object-cover rounded-full" />
            ) : (
              <span className="text-5xl text-gray-700 font-bold">
                {user.displayName ? user.displayName[0].toUpperCase() : user.email[0].toUpperCase()}
              </span>
            )}
          </div>
          <h2 className="text-2xl font-bold mb-1 font-['Space_Grotesk']">{user.displayName || 'No Name'}</h2>
          <p className="text-gray-600 mb-4 text-sm">{user.email}</p>
          <div className="w-full border-t pt-4 mt-4">
            <h3 className="text-lg font-semibold mb-2 font-['Space_Grotesk']">Profile Details</h3>
            <div className="flex flex-col gap-2 text-sm">
              <div><span className="font-medium">Name:</span> {user.displayName || 'N/A'}</div>
              <div><span className="font-medium">Email:</span> {user.email}</div>
              <div><span className="font-medium">User ID:</span> {user.uid}</div>
            </div>
          </div>
          <div className="w-full border-t pt-4 mt-4">
            <h3 className="text-lg font-semibold mb-2 font-['Space_Grotesk']">Edit Profile (coming soon)</h3>
            <p className="text-gray-400 text-sm">Profile editing will be available in a future update.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage; 